import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import Cauliflower from 'assets/Cauliflower.jpg';
import Chard from 'assets/Rainbow-Chard.jpeg';
import Clementine from 'assets/Clementine.png';
import RainbowPeppers from 'assets/RainbowPeppers.png';
// import

export interface ProductType {
   id: number | string;
   title: string;
   name: string;
   price: number;
   img: string;
   discount?: number;
   supply?: number | 0;
   stock?: boolean;
}

// export interface initialStateType extends ProductType{

// }

const products: ProductType[] = [
   {
      title: '1lb',
      name: 'Rainbow Chard',
      stock: true,
      price: 12,
      img: Chard,
      id: 0
   },
   {
      title: '5ct',
      name: 'Clementine',
      stock: true,
      price: 13,
      img: Clementine,
      id: 1
   },
   {
      title: 'each',
      name: 'Green Leaf Lettuce',
      stock: true,
      price: 10.5,
      img: Cauliflower,
      id: 2
   },
   {
      title: '5ct',
      name: 'Rainbow peppers',
      discount: 10,
      price: 12.5,
      img: RainbowPeppers,
      id: 3
   },
   {
      title: '1lb',
      name: 'Rainbow Chard',
      price: 12,
      img: Chard,
      id: 4
   },
   {
      title: '5ct',
      name: 'Clementine',
      stock: true,
      price: 13,
      img: Clementine,
      id: 5
   },
   {
      title: 'each',
      name: 'Green Leaf Lettuce',
      stock: true,
      price: 10.5,
      img: Cauliflower,
      id: 6
   },
   {
      title: '5ct',
      name: 'Rainbow peppers',
      discount: 15,
      price: 12.5,
      img: RainbowPeppers,
      id: 7
   }
];

const cartSlice = createSlice({
   name: 'cart',
   //    initialState: [] as ProductType[],
   initialState: products,
   reducers: {
      //   addToCart: (state, action: PayloadAction<ProductType>) => {
      //      const productIndex = state.findIndex((product) => product.id === action.payload.id);
      //      if (productIndex !== -1) {
      //         state[productIndex].amount += 1;
      //      } else {
      //         state.push({ ...action.payload, amount: 1 });
      //      }
      //   },
      //   removeFromCart: (state, action: PayloadAction<number>) => {
      //      const productIndex = state.findIndex((product) => product.id === action.payload);
      //      if (state[productIndex].amount > 1) {
      //         state[productIndex].amount -= 1;
      //      } else {
      //         return state.filter((i) => i.id !== action.payload);
      //      }
      //   },
      //   updateFromCart: (state, action: PayloadAction<ProductType>) => {
      //      if (state.find((i) => i.id === action.payload.id)) {
      //         return state.map((i) => {
      //            if (i.id === action.payload.id) {
      //               return action.payload;
      //            }
      //            return i;
      //         });
      //      }
      //      return state;
      //   }
   }
});

// export const { addToCart, removeFromCart, updateFromCart } = cartSlice.actions;
export const getProductsSelector = (state: RootState) => state.products;
export const getProductInCart = (state: RootState) => state.cart.findIndex;
// export const geTotalCartPrice = (state: RootState) => state.products.reduce((acc, next) => (acc += next.amount * next.amount), 0);
export default cartSlice.reducer;
